import React from 'react'
import { NavLink } from 'react-router-dom'
import { useDiscoveredYears } from '../../utils/useDiscoveredYears'
import { conferenceMeta } from '../../data/conferenceMeta'

export const Sidebar = (props) => {
	const { years } = useDiscoveredYears();

	return (
		<>
		  <div className="menu">
		    <ul>
		      <li className="here"><NavLink exact className="menu" to="/">Home</NavLink></li>
			  {years.map((year) => {
			  	const meta = conferenceMeta[year];
			  	return (
			  		<React.Fragment key={year}>
			  			<li className="label"><NavLink exact className="menu" to={`/irim3d/${year}`}>{year} I-RIM Conference</NavLink></li>
			  			{meta && meta.hasSessions && (
			  				<li className="menu"><NavLink exact className="menu" to={`/content/list/session/${year}`}>By Session</NavLink></li>
			  			)}
			  			<li className="menu"><NavLink exact className="menu" to={`/author/irim3d/${year}`}>By Author</NavLink></li>
			  		</React.Fragment>
			  	);
			  })}
		      </ul>
  		</div>

	    </>


	)
}
